/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProduct } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProduct';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProduct';

/**
 * 
 * @export
 * @interface FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront
 */
export interface FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront {
    /**
     * 
     * @type {Array<FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProduct>}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront
     */
    Products: Array<FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProduct>;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront(value: object): value is FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront {
    if (!('Products' in value) || value['Products'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontFromJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront {
    if (json == null) {
        return json;
    }
    return {
        
        'Products': ((json['Products'] as Array<any>).map(FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductFromJSON)),
    };
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontToJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontToJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontToJSONTyped(value?: FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Products': ((value['Products'] as Array<any>).map(FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductToJSON)),
    };
}

